import { createAction } from "@reduxjs/toolkit";
import { PRIMARY_HEX } from "../../theme/primary";

export const toggleState = createAction("changeState", (state) => {
  return {
    payload: state,
  };
});

export const updateBrandColor = createAction("brandColor", (color) => {
  return {
    payload: { brandColor: color || PRIMARY_HEX },
  };
});

export const setCommodityRates = createAction(
  "setCommodityRates",
  (commodity, rate) => ({ payload: { commodity, rate } }),
);

export const setDashboardData = createAction(
  "setDashboardData",
  (estateId, commodity, data) => ({ payload: { estateId, commodity, data } }),
);

export const clearDashboardData = createAction("clearDashboardData");
